import { render, staticRenderFns } from "./SelectCompanyType.vue?vue&type=template&id=ce95ef06&"
import script from "./SelectCompanyType.vue?vue&type=script&lang=ts&"
export * from "./SelectCompanyType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports